var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import Button from '../Button';
import CircularProgress from '@mui/material/CircularProgress';

var styles = function styles() {
  return {
    root: {
      minWidth: 64,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    startIcon: {
      margin: 0
    },
    label: {
      display: 'flex',
      flexDirection: 'column'
    }
  };
};

var VerticalButton = React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      classes = _ref.classes,
      selected = _ref.selected,
      startIcon = _ref.startIcon,
      loading = _ref.loading,
      _ref$sizeLoading = _ref.sizeLoading,
      sizeLoading = _ref$sizeLoading === undefined ? 18 : _ref$sizeLoading,
      props = _objectWithoutProperties(_ref, ['children', 'classes', 'selected', 'startIcon', 'loading', 'sizeLoading']);

  return React.createElement(
    Button,
    _extends({
      classes: {
        root: classes.root,
        startIcon: classes.startIcon
      },
      selected: selected,
      startIcon: loading ? React.createElement(CircularProgress, { size: sizeLoading }) : startIcon,
      ref: ref
    }, props),
    children
  );
});

VerticalButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  classes: PropTypes.shape({
    root: PropTypes.string,
    startIcon: PropTypes.string,
    label: PropTypes.string
  }),
  startIcon: PropTypes.node,
  selected: PropTypes.bool,
  loading: PropTypes.bool,
  sizeLoading: PropTypes.number
};

export default withStyles(styles)(VerticalButton);